var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0987 0.375977H3.85972C1.89971 0.375977 0.31073 1.96488 0.31073 3.92494V23.1639C0.31073 25.124 1.89964 26.7129 3.85972 26.7129H13.3483L13.3645 17.3015H10.9194C10.6016 17.3015 10.3437 17.0445 10.3425 16.7268L10.3308 13.6931C10.3295 13.3736 10.5882 13.114 10.9077 13.114H13.3484V10.1827C13.3484 6.78093 15.4259 4.92865 18.4605 4.92865H20.9507C21.2693 4.92865 21.5276 5.18694 21.5276 5.50559V8.06361C21.5276 8.38213 21.2695 8.64036 20.951 8.64055L19.4228 8.64126C17.7725 8.64126 17.453 9.42547 17.453 10.5763V13.114H21.0793C21.4248 13.114 21.6929 13.4158 21.6522 13.7589L21.2926 16.7926C21.2582 17.0829 21.012 17.3016 20.7197 17.3016H17.4691L17.453 26.713H23.0988C25.0588 26.713 26.6477 25.1241 26.6477 23.1641V3.92494C26.6477 1.96488 25.0588 0.375977 23.0987 0.375977Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0fff674b29180c624402f03d9ba4a38d.svg";
export { ForwardRef as ReactComponent };